import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'GisAdministration',
  methods: {
    zoomToElement() {
      axios.post('/GIS/GetZoomToElementUrl', { ElementType: 17, ElementId: 10 })
        .then(response => {
          if (response.data.data.status == 0) {
            var url = response.data.url;
            window.open(url, '_blank');
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })

    },
  }
}